import query_string from "query-string";
class BaseImageLoader {
    config;
    defaultQuality = 75;
    constructor(config){
        this.config = config;
        if (config?.defaultQuality) this.defaultQuality = config.defaultQuality;
    }
    load(config) {
        this.validateConfig(config);
        const normalizedConfig = this.normalizeConfig(config);
        return this.transformUrl(normalizedConfig);
    }
    validateConfig(config) {
        if (!config.src) throw new Error("Image source URL is required");
        if (!config.width || config.width <= 0) throw new Error("Image width must be a positive number");
        if (void 0 !== config.quality && (config.quality < 1 || config.quality > 100)) throw new Error("Image quality must be between 1 and 100");
    }
    normalizeConfig(config) {
        return {
            ...config,
            quality: config.quality ?? this.defaultQuality
        };
    }
    extractDomain(url) {
        try {
            const urlObject = new URL(url);
            return urlObject.hostname.toLowerCase();
        } catch  {
            return "";
        }
    }
    buildQueryParams(params) {
        const queryString_ = query_string.stringify(params);
        return queryString_ ? `?${queryString_}` : "";
    }
    ensureProtocol(url, defaultProtocol = "https") {
        if (url.startsWith("//")) return `${defaultProtocol}:${url}`;
        if (!url.startsWith("http://") && !url.startsWith("https://")) return `${defaultProtocol}://${url}`;
        return url;
    }
}
export { BaseImageLoader };
